// extracted by mini-css-extract-plugin
export var cancelButton = "_mc-5";
export var content = "_mc-3";
export var createButton = "_mc-6";
export var drawerContainer = "_mc-0";
export var footer = "_mc-2";
export var header = "_mc-1";
export var orderFormColumn = "_mc-4";